import React from 'react';
import { IProduct } from '../Library/types';
import PropTypes from 'prop-types';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ListChildComponentProps } from 'react-window';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import DeleteIcon from '@material-ui/icons/ArrowForwardIos';
import MinusIcon from '@material-ui/icons/RemoveCircleOutlineOutlined';
import CartIcon from '@material-ui/icons/AddShoppingCartOutlined';
import RemoveCartIcon from '@material-ui/icons/RemoveShoppingCartOutlined'
import AddIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import { getProductDescriptionColor } from '../Library/helpers';
import TextField from '@material-ui/core/TextField';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import RatingPanel from './Material/Rating';
import {Rate_labels} from '../ApiClients/DummyData';
import Translate from './Material/Traductor';
import { GetLanguage } from '../Library/helpers';

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}
  
const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
}));

const useStyles = makeStyles(createStyles({
    img: {
        objectFit: 'contain',
    },
    root: {
        borderRadius: 0,
    },
    item: {
        // border: '1px solid #ccc',
        borderRadius: '15px',
        margin: '5px 10px',
        width: 'calc(100% - 20px)!important',
        boxShadow: '5px 5px 5px 0px rgba(0,0,0,0.31)',
        cursor: 'pointer',
        paddingBottom: '50px',
        position: 'relative',
    },
    bottomActionsContainer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '30px',
        borderTop: '1px solid rgba(0,0,0,0.31)',
        borderBottomLeftRadius: '15px',
        borderBottomRightRadius: '15px',
        padding: '5px 0px',
        color: '#284770',
    },
    quantIcon: {
        paddingTop: '3px',
        paddingBottom: '3px',
        color: '#284770',
        verticalAlign: 'middle',
    },
    bottomRightActionsContainer: {
        position: 'absolute',
        right: '0px',
        top: '0px',
        bottom: '0px',
        zIndex: 1,
        fontSize:'12px'
    },
    promotion: {
        //backgroundColor: '#f00',
        display: 'inline-block',
        padding: '5px 0px 5px 0px',
        //color: '#fff',
        verticalAlign: 'middle',
    },
    separator: {
        display: 'inline-block',
        borderRight: '1px solid rgba(0,0,0,0.31)',
        verticalAlign: 'middle',
        height: '100%',
        marginLeft: '15px'
    },
    textField: {
        marginLeft: '10px',
        marginRight: '10px',
        width: 70,
        textAlign: 'center'
    }
}));

const FarmerListItem = (props: ListChildComponentProps) => {
    const [expanded, setExpanded] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    
    const handleClick = (event:any) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const { index, style, data } = props;
    const classes = useStyles();
    let item: IProduct = data[0];
    let lang: string = data[1];

    let typeProperties : Array<string> = getProductDescriptionColor(item.category_sale, lang);

    //const imageB64 = item.image?new Buffer(item.image).toString("base64"):'';
    
    //imageB64 = `data:image/svg;base64,${imageB64.substring(8,imageB64.length)}`;
    return (
        <Card sx={{ maxWidth: 350 }} style={{border:'1px solid #ddd'}}>
            <CardHeader
                avatar={
                <Avatar 
                    sx={{ /*bgcolor: red[500] */}}
                    aria-label="recipe"
                    alt='' 
                    src={`${item.uri_img}`} 
                    classes={{
                        root: classes.root,
                        img: classes.img
                    }}
                >
                    
                </Avatar>
                }
                action={
                <IconButton onClick={handleClick} aria-label="settings">
                    <MoreVertIcon />
                </IconButton>
                }
                title={item.name}
                //subheader={`${item.base_price} ${item.price_unit} (${item.sale_unit[0]})`}
            />
            <CardMedia
                //onClick={item.onItemClick}
                component="img"
                height="150"
                image={`${item.uri_img}`}
                alt={item.name}
                //style={{cursor:'pointer'}}
            />
            <CardContent>
                {item.rates.reviews.length > 0?
                    <React.Fragment>
                        <RatingPanel
                            value={item.rates.qualification}
                            labels={Rate_labels}
                            precision={0.5}
                            readOnly={true}
                        />
                        <a href='#/farmers' style={{fontSize:12, paddingLeft:5}}>{`${Translate(lang, "label.farmer.01")} (${item.rates.reviews.length})`}</a>
                    </React.Fragment>
                :
                    <a style={{fontSize:12, paddingLeft:5}}>{`${Translate(lang, "label.farmer.02")}`}</a>
                }
                <Typography style={{marginTop:20, textAlign:'justify'}} variant="body2" color="text.secondary">
                {`${item.description}`}
                </Typography>
            </CardContent>

            <CardActions disableSpacing>
                <div style={{width:'90%', margin:'auto', textAlign:'center'}}>
                 
                    {/*<IconButton aria-label="add to favorites">
                    <FavoriteIcon />
                    </IconButton>
                    <IconButton aria-label="share">
                    <ShareIcon />
                </IconButton>*/}
                    <ExpandMore
                    expand={expanded}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="show more"
                    >
                    <ExpandMoreIcon />
                </ExpandMore>
                </div>
            </CardActions>
            <Menu
                style={{marginTop:40}}
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}

                >
                    <div onClick={()=>item.onOptionClick(1)}  style={{display:'flex',marginLeft:0}}>
                        <MenuItem style={{width:'100%', maxWidth:'200px', fontSize:14}} onClick={handleClose}><strong>{Translate(lang, "label.farmer.detail.02")}</strong></MenuItem>
                    </div>
                    <div onClick={()=>item.onOptionClick(2)}  style={{display:'flex',marginLeft:0, borderBottom:'1px #ddd solid', borderTop:'1px #ddd solid'}}>
                        <MenuItem style={{width:'100%', maxWidth:'200px', fontSize:14}} onClick={handleClose}><strong>{Translate(lang, "label.farmer.detail.03")}</strong></MenuItem>
                    </div>
                    <div onClick={()=>item.onOptionClick(3)}  style={{display:'flex',marginLeft:0}}>
                        <MenuItem style={{width:'100%', maxWidth:'200px', fontSize:14}} onClick={handleClose}><strong>{Translate(lang, "label.farmer.detail.04")}</strong></MenuItem>
                    </div>
            </Menu>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                <Typography paragraph>Más información: (horarios, localización, etc)</Typography>
                {/*<Typography paragraph>
                    Heat 1/2 cup of the broth in a pot until simmering, add saffron and set
                    aside for 10 minutes.
                </Typography>
                <Typography paragraph>
                    Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet over
                    medium-high heat. Add chicken, shrimp and chorizo, and cook, stirring
                    occasionally until lightly browned, 6 to 8 minutes. Transfer shrimp to a
                    large plate and set aside, leaving chicken and chorizo in the pan. Add
                    pimentón, bay leaves, garlic, tomatoes, onion, salt and pepper, and cook,
                    stirring often until thickened and fragrant, about 10 minutes. Add
                    saffron broth and remaining 4 1/2 cups chicken broth; bring to a boil.
                </Typography>
                <Typography paragraph>
                    Add rice and stir very gently to distribute. Top with artichokes and
                    peppers, and cook without stirring, until most of the liquid is absorbed,
                    15 to 18 minutes. Reduce heat to medium-low, add reserved shrimp and
                    mussels, tucking them down into the rice, and cook again without
                    stirring, until mussels have opened and rice is just tender, 5 to 7
                    minutes more. (Discard any mussels that don&apos;t open.)
                </Typography>
                <Typography>
                    Set aside off of the heat to let rest for 10 minutes, and then serve.
                </Typography>*/}
                </CardContent>
            </Collapse>
        </Card>
    );
}

FarmerListItem.propTypes = {
    index: PropTypes.number,
    style: PropTypes.object,
} as any;

export default FarmerListItem;